/*
 * @Author: www
 * @Date: 2019-03-24 14:55:39
 * @Last Modified by: www
 * @Last Modified time: 2020-05-16 21:12:11
 */
import { cloneDeep } from 'lodash';
import { getUserInfo } from '@/api/user.js';

export const ADD_USER = 'ADD_USER';
export const UPDATE_PORTRAIT = 'UPDATE_PORTRAIT';
export const RESET_USER = 'RESET_USER';

const initState = {
  id: null, // 用户id
  imUserId: null, // im初始化id
  nickname: '',
  realname: '',
  phone: '',
  email: '',
  headImgurl: '',
};

const mutations = {
  [ADD_USER](state, payload) {
    Object.assign(state, payload);
  },
  [UPDATE_PORTRAIT](state, payload) {
    state.portrait = payload;
  },
  [RESET_USER](state) {
    Object.assign(state, cloneDeep(initState));
  },
};

const actions = {
  async fetchUser({ commit }) {
    const user = await getUserInfo();
    commit(ADD_USER, user);
  },
};

const getters = {
  userInfo(state) {
    return state;
  },
  userId(state) {
    return state.id;
  },
  imUserId(state) {
    return state.imUserId;
  },
};

export default {
  name: 'user',
  namespaced: true,
  state: cloneDeep(initState),
  mutations,
  actions,
  getters,
};
